import { Currency } from '@/core/currency/interfaces';

const TTD: Currency = {
    name: 'Trinidad and Tobago Dollar',
    demonym: 'Trinidad and Tobago',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '780',
    symbol: 'TT$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TTD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default TTD;
